import { render, staticRenderFns } from "./FinanceView.vue?vue&type=template&id=665f5912&scoped=true&lang=pug"
import script from "./FinanceView.vue?vue&type=script&lang=js"
export * from "./FinanceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665f5912",
  null
  
)

export default component.exports